import axios, { type AxiosRequestConfig } from 'axios';
import { ApiResponse } from './baseApiService';
import { type EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';

/**
 * @deprecated Use CoreJsonAPIService instead.
 */
export default class ApiService {
  protected static async get<T>(djangoApp: EDjangoAppsEndpoints, suffix: string = '', params?: Record<string, any>, config?: AxiosRequestConfig) {
    return new ApiResponse<T>(await axios.get(`/api/${djangoApp}/${suffix}`, {
      ...config, params
    }));
  }

  protected static async put<T>(djangoApp: EDjangoAppsEndpoints, suffix: string = '', data?: Record<string, any>, config?: AxiosRequestConfig) {
    return new ApiResponse<T>(await axios.put(`/api/${djangoApp}/${suffix}`, data, config));
  }

  protected static async post<T>(djangoApp: EDjangoAppsEndpoints, suffix: string = '', data?: Record<string, any>, config?: AxiosRequestConfig) {
    return new ApiResponse<T>(await axios.post(`/api/${djangoApp}/${suffix}`, data, config));
  }

  protected static async delete<T>(djangoApp: EDjangoAppsEndpoints, suffix: string = '', config?: AxiosRequestConfig) {
    return new ApiResponse<T>(await axios.delete(`/api/${djangoApp}/${suffix}`, config));
  }
}
